import axios from "./axios";

export interface ModerationQuery {
  username?: string;
  userId?: string;
  contentId?: string;
  contentPartId?: string;
  skip?: number;
  take?: number;
}

export async function fetchModerationComments(query: ModerationQuery) {
  const res = await axios.get("/moderation/comments", { params: query });
  return {
    items: res.data?.items ?? [],
    totalCount: Number(res.data?.totalCount ?? res.data?.items?.length ?? 0),
  };
}

export async function hideComment(commentId: string, reason?: string) {
  const res = await axios.post("/moderation/comments/hide", { commentId, reason });
  return Boolean(res.data?.success ?? true);
}

export async function unhideComment(commentId: string, reason?: string) {
  const res = await axios.post("/moderation/comments/unhide", { commentId, reason });
  return Boolean(res.data?.success ?? true);
}

export async function deleteComment(commentId: string, reason?: string) {
  const res = await axios.post("/moderation/comments/delete", { commentId, reason });
  return Boolean(res.data?.success ?? true);
}
